import axios, { AxiosInstance } from "axios";
import { requestInterceptor } from "./request";
import { responseInterceptor, createResponseErrorInterceptor } from "./response";

export const api: AxiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    timeout: 60000,
    withCredentials: true,
});

api.interceptors.request.use(requestInterceptor);

api.interceptors.response.use(
    responseInterceptor,
    createResponseErrorInterceptor(api)
);
